export const features = [
  {
    id: "01",
    title: "Two-Factor Authentication",
    description:
      "For further safety and security, users should verify using a QR code, Pin code, or OTP.",
  },
  {
    id: "02",
    title: "Transaction History",
    description:
      "Admins and users may view the specifics of their bitcoin transactions.",
  },
  {
    id: "03",
    title: "Quick transactional times",
    description:
      "Our User-Centric gateways achieve extremely fast transaction times.",
  },
  {
    id: "04",
    title: "No-Hassle Conversion",
    description:
      "Convert and transfer your fiat dollars into cryptos in a bug-free environment.",
  },
  {
    id: "05",
    title: "Payment Options",
    description:
      "This functionality is introduced to close loopholes. Users can change their fiat currency into cryptocurrency using a credit or debit card.",
  },
  {
    id: "06",
    title: "Several Blockchain Currencies",
    description:
      "Multiple blockchain currencies, including Bitcoin, Ethereum, EOS, and other payment methods, are merged and listed.",
  },
  {
    id: "07",
    title: "Support for several languages",
    description:
      "Users can pick their chosen language because it is universally recognised and used.",
  },
  {
    id: "08",
    title: "Several Wallets",
    description:
      "For an unbroken crypto transfer, many wallets can be integrated into a single application.",
  },
  {
    id: "09",
    title: "Users Owned",
    description:
      "Users have total control over their cash and private keys, providing transparency and increased security.",
  },
  {
    id: "10",
    title: "Data Safety",
    description:
      "The saved data is encrypted using cutting-edge cryptographic algorithms.",
  },
];

export const hireFeatures = [
  {
    img: require("../../../image/cryptopayment/hir_img_one.webp"),
    label: "Multi-Currency support",
  },
  {
    img: require("../../../image/cryptopayment/hir_img_two.webp"),
    label: "Avant-garde security",
  },
  {
    img: require("../../../image/cryptopayment/hir_img_three.webp"),
    label: "Immutable records",
  },
  {
    img: require("../../../image/cryptopayment/hir_img_four.webp"),
    label: "Lightning transactions",
  },
  {
    img: require("../../../image/cryptopayment/hir_img_five.webp"),
    label: "Maximum number of users",
  },
  {
    img: require("../../../image/cryptopayment/hir_img_six.webp"),
    label: "No chargebacks",
  },
  {
    img: require("../../../image/cryptopayment/hir_img_seven.webp"),
    label: "Cross-chain compatibility",
  },
];
